import { useIntl } from 'react-intl';

import { FocusRingVariants } from '@calm-web/design-system';

import Image from '@/components/image/NextImage';
import { SchoolSectionProps } from '@/components/schools/SchoolsLayout/types';
import GridWrapper from '@/components/ui/GridWrapper';

import messages from './messages';
import {
	Background,
	Blurb,
	CtaButton,
	Grid,
	Heading,
	ImageGridWrapper,
	ImageWrapper,
	Photo,
	Wrapper,
} from './styles';

const TakeCare = ({ onCtaClick }: SchoolSectionProps) => {
	const { formatMessage } = useIntl();
	return (
		<Wrapper>
			<ImageWrapper>
				<Background src="/_n/images/schools/take-care-collage.webp" />
				<ImageGridWrapper>
					<GridWrapper columns={1}>
						<Photo>
							<Image
								fill
								style={{ objectFit: 'cover', objectPosition: 'center' }}
								src="/_n/images/schools/take-care-photo.webp"
								alt="Woman smiling while using phone"
							/>
						</Photo>
					</GridWrapper>
				</ImageGridWrapper>
			</ImageWrapper>
			<GridWrapper columns={1}>
				<Heading>{formatMessage(messages.heading)}</Heading>
				<Grid>
					<Blurb>{formatMessage(messages.blurb1)}</Blurb>
					<Blurb>{formatMessage(messages.blurb2)}</Blurb>
					<Blurb>{formatMessage(messages.blurb3)}</Blurb>
				</Grid>
				<CtaButton
					backgroundColor="schoolBlue"
					onPress={() => onCtaClick(messages.heading.defaultMessage)}
					focusRingVariant={FocusRingVariants.Dark}
				>
					{formatMessage(messages.button)}
				</CtaButton>
			</GridWrapper>
		</Wrapper>
	);
};

export default TakeCare;
